/* Product checkout remains available at every screen size; local previews only review the selection. */
(() => {
  if (window.mmMobileBuyReady) return;
  window.mmMobileBuyReady = true;
  const instances = new Map();
  const mobile = matchMedia('(max-width: 850px)');
  const body = document.body;
  const page = document.documentElement;
  const basePadding = getComputedStyle(body).paddingBottom;

  function reserveSpace() {
    const enabled = instances.size > 0 && (mobile.matches || [...instances.keys()].some(bar => bar.dataset.mobileBuy === 'product'));
    body.classList.toggle('mm-mobile-buy-enabled', enabled);
    page.classList.toggle('mm-mobile-buy-enabled', enabled);
    if (enabled) body.style.setProperty('--mm-mobile-buy-base-padding', basePadding);
    else {
      body.style.removeProperty('--mm-mobile-buy-base-padding');
      page.style.removeProperty('--mm-mobile-buy-height');
    }
  }

  function setup(bar) {
    if (instances.has(bar)) return;
    const product = bar.dataset.mobileBuy === 'product';
    const scope = bar.closest('.shopify-section') || document;
    const root = scope.querySelector(product ? '[data-mm-product]' : '[data-mm-root]');
    const sourcePrice = root?.querySelector(product ? '[data-product-total]' : '[data-ticket-price="standard"]');
    const target = root?.querySelector(product ? '[data-product-review]' : '#tickets');
    const finalTarget = root?.querySelector(product ? '[data-product-buy]' : '[data-home-final]');
    const heroCTA = product ? null : root?.querySelector('[data-home-hero] a[href="#tickets"]');
    if (!root || !sourcePrice || !target || (!product && !heroCTA)) return;
    const price = bar.querySelector('[data-mobile-buy-price]');
    const label = bar.querySelector('[data-mobile-buy-label]');
    const reviewButton = bar.querySelector('[data-mobile-buy-review]');
    const quantityInput = product ? root.querySelector('#mm-product-quantity') : null;
    const selectionDialog = product ? root.querySelector('.mm-product-dialog') : null;
    const controller = new AbortController();
    const { signal } = controller;
    reviewButton?.addEventListener('click', event => {
      // Live checkout submits the associated native form with its checkout intent.
      if (target.disabled) { event.preventDefault(); return; }
      if (reviewButton.hasAttribute('data-product-checkout')) return;
      // A local preview can only open the existing selection dialog.
      target.click();
      if (selectionDialog?.open) selectionDialog.addEventListener('close', () => {
        sync();
        if (!bar.hidden) reviewButton.focus({ preventScroll:true });
      }, { once:true, signal });
    }, { signal });
    let frame;

    const initiallyVisible = (element, fullyVisible = product) => {
      const bounds = element.getBoundingClientRect();
      return bounds.width > 0 && bounds.height > 0 && (fullyVisible
        ? bounds.top >= 0 && bounds.bottom <= window.innerHeight
        : bounds.bottom >= 0 && bounds.top <= window.innerHeight);
    };
    let targetVisible = initiallyVisible(target);
    let finalVisible = finalTarget ? initiallyVisible(finalTarget, true) : false;
    let heroVisible = heroCTA ? initiallyVisible(heroCTA) : false;
    function sync() {
      frame = null;
      const value = sourcePrice.textContent.trim();
      if (price.textContent !== value) price.textContent = value;
      if (product && label && quantityInput) {
        const quantity = Number(quantityInput.value);
        const beforeGroupSavings = root.dataset?.productGroupSavings === 'true';
        label.textContent = beforeGroupSavings ? 'Before group savings' : `${quantity} ${quantity === 1 ? 'attendee' : 'attendees'} · total`;
        if (reviewButton) {
          reviewButton.disabled = target.disabled;
          reviewButton.setAttribute('aria-label', `${reviewButton.hasAttribute('data-product-checkout') ? 'Checkout' : 'Preview selection'} for ${quantity} ${quantity === 1 ? 'attendee' : 'attendees'}, ${beforeGroupSavings ? 'subtotal before group savings' : 'total'} ${value}`);
        }
      }
      const priceAvailable = Boolean(value) && !/^[—–-]$/.test(value) && (!product || !target.disabled);
      const blocked = document.querySelector('dialog[open], .mm-mobile-menu[open], .mmd-mobile-nav:not([hidden])');
      bar.hidden = (!product && (!mobile.matches || heroVisible || targetVisible || finalVisible)) || !priceAvailable || Boolean(blocked);
      if (!bar.hidden) page.style.setProperty('--mm-mobile-buy-height', `${bar.getBoundingClientRect().height}px`);
    }
    const schedule = () => { if (frame == null) frame = requestAnimationFrame(sync); };
    const visibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === target) targetVisible = entry.isIntersecting && (!product || entry.intersectionRatio >= 0.99);
        if (entry.target === finalTarget) finalVisible = entry.isIntersecting && entry.intersectionRatio >= 0.99;
        if (entry.target === heroCTA) heroVisible = entry.isIntersecting;
      });
      schedule();
    }, { threshold:[0, 0.99, 1] });
    visibility.observe(target);
    if (finalTarget) visibility.observe(finalTarget);
    if (heroCTA) visibility.observe(heroCTA);
    const changes = new MutationObserver(schedule);
    changes.observe(sourcePrice, { childList:true, characterData:true, subtree:true });
    if (product) changes.observe(target, { attributes:true, attributeFilter:['disabled'] });
    document.querySelectorAll('dialog, .mm-mobile-menu, .mmd-mobile-nav').forEach(element => changes.observe(element, { attributes:true, attributeFilter:['open', 'hidden'] }));
    const size = new ResizeObserver(schedule);
    size.observe(bar);
    window.addEventListener('resize', schedule, { signal });
    window.addEventListener('pageshow', event => {
      // A restored product page may predate a basket change on another page.
      // Re-render from Shopify so Checkout cannot add the same ticket again.
      if (event.persisted && reviewButton?.hasAttribute('data-product-checkout')) {
        window.location.reload();
        return;
      }
      schedule();
    }, { signal });
    mobile.addEventListener('change', () => { reserveSpace(); schedule(); }, { signal });
    instances.set(bar, () => {
      controller.abort();
      visibility.disconnect();
      changes.disconnect();
      size.disconnect();
      cancelAnimationFrame(frame);
      bar.hidden = true;
      instances.delete(bar);
      reserveSpace();
    });
    reserveSpace();
    sync();
  }

  const bars = context => [...(context.matches?.('[data-mobile-buy]') ? [context] : []), ...context.querySelectorAll('[data-mobile-buy]')];
  bars(document).forEach(setup);
  document.addEventListener('shopify:section:load', event => bars(event.target).forEach(setup));
  document.addEventListener('shopify:section:unload', event => bars(event.target).forEach(bar => instances.get(bar)?.()));
})();
